import { useState } from "react";
import { IAddress } from "./types";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { useSetObjectValue } from "../../../hooks/useSetObjectValue";

interface EditAddressFormProps extends IAddress {
    objectId: string,
    resourceGroupId: string,
}

const EditAddressForm = (props: EditAddressFormProps) => {

    const [country, setCountry] = useSetObjectValue(props.objectId, props.resourceGroupId, "Address/Country", props.country);
    const [postalCode, setPostalCode] = useSetObjectValue(props.objectId, props.resourceGroupId, "Address/PostalCode", props.postalCode);
    const [addressLine1, setAddressLine1] = useSetObjectValue(props.objectId, props.resourceGroupId, "Address/AddressLine1", props.addressLine1);
    const [city, setCity] = useSetObjectValue(props.objectId, props.resourceGroupId, "Address/City", props.city);


    const onCountryChanged = (e: any) => setCountry(e.target.value)
    const onPostalChanged = (e: any) => setPostalCode(e.target.value);
    const onCityChanged = (e: any) => setCity(e.target.value);
    const onAddressLine1Changed = (e: any) => setAddressLine1(e.target.value);

    return (
        <>
            <FormControl
                label={() => "Country"}
                caption={() => "Enter the name of the country"}
            >
                <Input value={country}  placeholder="Country ..." clearable onChange={onCountryChanged} />
            </FormControl>
            <FormControl
                label={() => "Postal code/Region"}
                caption={() => "Enter the Postal code"}
            >
                <Input value={postalCode}  placeholder="Postal code ..." type="numeric" clearable onChange={onPostalChanged} />
            </FormControl>
            <FormControl
                label={() => "City"}
                caption={() => "Enter the City"}
            >
                <Input value={city}  placeholder="City ..."  clearable onChange={onCityChanged} />
            </FormControl>
            <FormControl
                label={() => "Address"}
                caption={() => "Enter the Address"}
            >
                <Input value={addressLine1}  placeholder="Address ..."  clearable onChange={onAddressLine1Changed} />
            </FormControl>
        </>
    )

}

export default EditAddressForm